const HERO_DATA = {
  title: "A New Breed of Canuck!", 
  // hook: "Canuckz V2 Drop",
  
  hook: "",
  blurb: "Canuckz-NFT is a collection of Canuckz Characters – unique digital collectibles living on the Cardano blockchain. Your Canuck doubles as your Canucks Publishing membership card, and grants access to members-only benefits. This includes access to participating whitelists for upcoming drops that are minting with Canucks Publishing, members only giveaways, airdrops and so much more. Holding more Canuckz of various species will get you access to higher tiers of perks!"
}

export default HERO_DATA;